var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconWifi = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 54,
  height: 14,
  viewBox: "0 0 54 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.5996 4C10.5996 3.44772 11.0473 3 11.5996 3H12.5996C13.1519 3 13.5996 3.44772 13.5996 4V12C13.5996 12.5523 13.1519 13 12.5996 13H11.5996C11.0473 13 10.5996 12.5523 10.5996 12V4Z",
  fill: "#001246"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5996 2C15.5996 1.44772 16.0473 1 16.5996 1H17.5996C18.1519 1 18.5996 1.44772 18.5996 2V12C18.5996 12.5523 18.1519 13 17.5996 13H16.5996C16.0473 13 15.5996 12.5523 15.5996 12V2Z",
  fill: "#001246"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.59961 7.5C5.59961 6.94772 6.04732 6.5 6.59961 6.5H7.59961C8.15189 6.5 8.59961 6.94772 8.59961 7.5V12C8.59961 12.5523 8.15189 13 7.59961 13H6.59961C6.04732 13 5.59961 12.5523 5.59961 12V7.5Z",
  fill: "#001246"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.599609 10C0.599609 9.44772 1.04732 9 1.59961 9H2.59961C3.15189 9 3.59961 9.44772 3.59961 10V12C3.59961 12.5523 3.15189 13 2.59961 13H1.59961C1.04732 13 0.599609 12.5523 0.599609 12V10Z",
  fill: "#001246"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.35,
  d: "M30.5996 1H47.5996C49.5326 1 51.0996 2.567 51.0996 4.5V9.5C51.0996 11.433 49.5326 13 47.5996 13H30.5996C28.6666 13 27.0996 11.433 27.0996 9.5V4.5C27.0996 2.567 28.6666 1 30.5996 1Z",
  stroke: "#001246"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M52.5996 5.5V9.72034C53.4487 9.36291 54.0008 8.5314 54.0008 7.61017C54.0008 6.68894 53.4487 5.85744 52.5996 5.5Z",
  fill: "#001246"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5996 4.5C28.5996 3.39543 29.495 2.5 30.5996 2.5H47.5996C48.7042 2.5 49.5996 3.39543 49.5996 4.5V9.5C49.5996 10.6046 48.7042 11.5 47.5996 11.5H30.5996C29.495 11.5 28.5996 10.6046 28.5996 9.5V4.5Z",
  fill: "#001246"
})));
export default SvgIconWifi;